import { formatCurrency } from '../../../helpers'
import { TicketType } from '../../../services/Event/types'

/**
 * Regra do formulário "Tire suas dúvidas", espelhada da API (Event::HELP_FORM_MIN_TICKET_PRICE
 * e Event::ticketsAllowHelpForm). É um canal de atendimento consultivo: só faz sentido em evento
 * de ticket alto, então só é liberado com ao menos um ingresso PAGO a partir deste valor.
 *
 * Vale para o evento avulso e para cada edição de uma série — mudou na API, muda aqui.
 */
export const HELP_FORM_MIN_TICKET_PRICE = 1000

export const HELP_FORM_MIN_TICKET_PRICE_LABEL = formatCurrency(HELP_FORM_MIN_TICKET_PRICE)

export const HELP_FORM_RULE_TEXT = `Esta opção só pode ser ativada em eventos com pelo menos um ingresso pago de ${HELP_FORM_MIN_TICKET_PRICE_LABEL} ou mais.`

/** Texto padrão de quando o switch está travado — o formulário de série troca por um mais específico. */
export const HELP_FORM_BLOCKED_HINT = `${HELP_FORM_RULE_TEXT} Cadastre um ingresso pago nesse valor para liberá-la.`

/** A caução de um ingresso gratuito não conta: ela não é o valor do ingresso. */
export const allowsHelpForm = (tickets: { type: TicketType; price: number }[]): boolean =>
  tickets.some((ticket) => ticket.type === 'PAID' && Number(ticket.price) >= HELP_FORM_MIN_TICKET_PRICE)
